/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useRef, useEffect} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import {useMutation, useQuery} from '@tanstack/react-query'
import {KTSVG} from '../../../../../_metronic/helpers'
import { StepperComponent } from '../../../../../_metronic/assets/ts/components'
import { useToast } from '../../../components/Toats'
import { LoadingSpan } from '../../../components/Loadings/loadingSpan'
import { Loading } from '../../../components/Loadings/loading'
import { useFormik } from 'formik'
import * as Yup from "yup";
import { useAuth } from '../../../../modules/auth'
import { postTag, updateTag } from '../../../../services/tagsService'
import { getPlantsAllSimple } from '../../../../services/plantsService'
import { ListPlantsLinked } from './components/listPlantsLinked'

type DataForm = {
  name: string | null,
  color: string | null,
  description: string | null,
  is_global: boolean,
  status: 'ATIVO' | 'INATIVO',
  idsPlants: string[]
}

type Props = {
    id?: string;
    data?: DataForm;
    show: boolean
    handleClose: () => void
}

const DEFAULT_VALUES: DataForm = {
  name: null,
  color: '#3498DB',
  description: null,
  is_global: false,
  status: 'ATIVO',
  idsPlants: []
}

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Informe um nome para a tag."),
  color: Yup.string()
    .matches(/^#([A-Fa-f0-9]{6})$/, 'Use hexadecimal #RRGGBB')
    .required('Cor obrigatória'),
  description: Yup.string(),
  is_global: Yup.boolean(),
  status: Yup.string(),
  idsPlants: Yup.array().of(Yup.string()).notRequired().default([]),
});

const modalsRoot = document.getElementById('root-modals') || document.body

const ModalAddUpdateTag = ({show, handleClose, data, id}: Props) => {

  const { toggleToast } = useToast();
  const user = useAuth();
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)

  const isAdmin = user?.currentUser?.role?.slug === 'ADMIN';

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const buildPayload = (values: DataForm) => {
    const myData: any = {
      name: values.name,
      color: values.color,
      description: values.description,
      status: values.status,
      idsPlants: values.idsPlants,
    }
    if (isAdmin) myData.is_global = values.is_global
    return myData
  }

  const { data: plants = [], isLoading: loadingPlants } = useQuery({
    queryKey: ['getPlantsAllSimpleTagModal'],
    queryFn: async () => {
      try {
        const myPlants = await getPlantsAllSimple()
        return Array.isArray(myPlants) ? myPlants : myPlants?.data || []
      } catch (error) {
        console.log(error)
        toggleToast("Erro ao buscar a lista de usinas. ", "error")
        throw error
      }
    },
    enabled: show,
    staleTime: 1000 * 60 * 5,
  })

  const createTagMutation = useMutation({
    mutationFn: (values: DataForm) => postTag(buildPayload(values)),
    onSuccess: () => {
      toggleToast("Sucesso ao cadastrar a tag. ", "success")
    },
    onError: (error: any) => {
      console.log(error)
      toggleToast(error?.response?.data?.message || "Erro ao cadastrar a tag. ", "error")
    },
    onSettled: () => {
      closed()
    },
  })

  const updateTagMutation = useMutation({
    mutationFn: ({ values, tagId }: { values: DataForm; tagId: string }) =>
      updateTag(buildPayload(values), tagId),
    onSuccess: () => {
      toggleToast("Sucesso ao atualizar a tag. ", "success")
    },
    onError: (error: any) => {
      console.log(error)
      toggleToast(error?.response?.data?.message || "Erro ao atualizar a tag. ", "error")
    },
    onSettled: () => {
      closed()
    },
  })

  const loading = createTagMutation.isPending || updateTagMutation.isPending

  const formik = useFormik({
    initialValues: DEFAULT_VALUES,
    validationSchema,
    validateOnChange: false,
    onSubmit: (values) => {
      if (id) {
        updateTagMutation.mutate({ values, tagId: id })
      } else {
        createTagMutation.mutate(values)
      }
    },
  });

  const closed = () => {
    formik.setValues(DEFAULT_VALUES)
    handleClose()
  }

  useEffect(() => {
    if (data) {
      formik.setValues({
        name: data.name ? data.name : null,
        color: data.color ? data.color : '#3498DB',
        description: data.description ? data.description : null,
        is_global: !!data.is_global,
        status: data.status ? data.status : 'ATIVO',
        idsPlants: data.idsPlants ? data.idsPlants : [],
      })
    } else {
      formik.setValues(DEFAULT_VALUES)
    }
  }, [show])

  const tagColor = formik.values.color || '#3498DB'
  const tagName = formik.values.name || 'Nome da tag'
  const plantsCount = (formik.values.idsPlants || []).length

  return createPortal(
    <Modal
      id='kt_modal_create_tag'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-900px'
      show={show}
      onHide={closed}
      onEntered={loadStepper}
      backdrop={true}
    >
      <div className='modal-header py-4'>
        <h3 className='card-title align-items-start flex-column mb-0'>
          <span className='card-label fw-bold fs-3'>{id ? 'Editar' : 'Adicionar'} Tag</span>
        </h3>

        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </div>
      </div>

      <div className='modal-body py-6 px-lg-8'>
        <div ref={stepperRef}>
          <form noValidate>
            <div className='row g-4 mb-4'>
              <div className='col-md-8'>
                <div className='row g-3'>
                  <div className='col-md-7'>
                    <label className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                      <span className='required'>Nome</span>
                    </label>
                    <input
                      type='text'
                      className='form-control form-control-solid'
                      name='name'
                      placeholder='Ex: Prioridade Alta'
                      value={formik.values.name || ''}
                      onChange={formik.handleChange('name')}
                    />
                    {formik.errors.name && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik.errors.name as string}</div>
                      </div>
                    )}
                  </div>

                  <div className='col-md-5'>
                    <label className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                      <span className='required'>Cor</span>
                    </label>
                    <div className='d-flex align-items-center gap-2'>
                      <input
                        type='color'
                        className='form-control form-control-color form-control-solid p-1'
                        style={{ width: '3rem', height: '2.75rem', cursor: 'pointer' }}
                        value={tagColor}
                        onChange={formik.handleChange('color')}
                      />
                      <input
                        type='text'
                        className='form-control form-control-solid'
                        name='color'
                        value={formik.values.color || ''}
                        onChange={formik.handleChange('color')}
                      />
                    </div>
                    {formik.errors.color && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik.errors.color as string}</div>
                      </div>
                    )}
                  </div>

                  <div className='col-12'>
                    <label className='d-flex align-items-center fs-6 fw-semibold mb-2 required'>
                      <span>Descrição</span>
                    </label>
                    <input
                      type='text'
                      className='form-control form-control-solid'
                      name='description'
                      placeholder='Descrição opcional da tag'
                      value={formik.values.description || ''}
                      onChange={formik.handleChange('description')}
                    />
                  </div>

                  <div className='col-md-12'>
                    <label className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                      <span>Status</span>
                    </label>
                    <select
                      className='form-select form-select-solid'
                      value={formik.values.status}
                      onChange={formik.handleChange('status')}
                    >
                      <option value='ATIVO'>ATIVO</option>
                      <option value='INATIVO'>INATIVO</option>
                    </select>
                  </div>

                  {isAdmin && (
                    <div className='col-md-6 d-flex align-items-end'>
                      <div className='form-check form-check-custom form-check-solid mb-2'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          checked={!!formik.values.is_global}
                          onChange={(event) => formik.setFieldValue('is_global', event.target.checked)}
                        />
                        <label className='form-check-label'>Tag genérica (todas empresas)</label>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='col-md-4'>
                <label className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                  <span>Preview</span>
                </label>
                <div
                  className='rounded-3 h-100 d-flex flex-column justify-content-center align-items-center p-5'
                  style={{
                    minHeight: '11rem',
                    background: `linear-gradient(145deg, ${tagColor}22 0%, ${tagColor}0A 55%, #f5f8fa 100%)`,
                    border: `1px solid ${tagColor}33`,
                  }}
                >
                  <span
                    className='badge fs-6 fw-bold px-4 py-3 mb-3'
                    style={{
                      backgroundColor: tagColor,
                      color: '#fff',
                      borderRadius: '0.65rem',
                      letterSpacing: '0.02em',
                      boxShadow: `0 8px 20px ${tagColor}55`,
                    }}
                  >
                    {tagName}
                  </span>
                  <div className='d-flex flex-wrap justify-content-center gap-2'>
                    <span className='badge badge-light-dark fw-semibold'>{tagColor.toUpperCase()}</span>
                    <span
                      className={`badge fw-semibold ${
                        formik.values.status === 'ATIVO' ? 'badge-light-success' : 'badge-light-danger'
                      }`}
                    >
                      {formik.values.status}
                    </span>
                    {isAdmin && (
                      <span
                        className={`badge fw-semibold ${
                          formik.values.is_global ? 'badge-light-primary' : 'badge-light-info'
                        }`}
                      >
                        {formik.values.is_global ? 'Global' : 'Empresa'}
                      </span>
                    )}
                    <span className='badge badge-light fw-semibold'>
                      {plantsCount} {plantsCount === 1 ? 'usina' : 'usinas'}
                    </span>
                  </div>
                  {formik.values.description && (
                    <span className='text-muted fs-8 mt-3 text-center px-2'>
                      {formik.values.description}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className='mb-2'>
              {loadingPlants ? (
                <div className='d-flex justify-content-center py-10'>
                  <Loading myClass='spinner-border spinner-border' />
                </div>
              ) : (
                <ListPlantsLinked
                  plants={plants}
                  className="card-xl-stretch bg-body mb-xl-8"
                  formik={formik}
                />
              )}
            </div>

            <div className='d-flex justify-content-end pt-2'>
              <button
                type='button'
                className='btn btn-lg btn-primary'
                disabled={loading}
                onClick={() => formik.handleSubmit()}
              >
                {id ? 'Editar' : 'Cadastrar'}{' '}
                {loading ? (
                  <LoadingSpan style={{ marginLeft: '0.5rem' }} />
                ) : (
                  <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-3 ms-2 me-0' />
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export {ModalAddUpdateTag}
